import styled from 'styled-components';
import { CharacteristicsStyled } from '../CharacteristicsStyled';
import { rem } from 'polished';
import { breakpoints } from '../../../../styles/theme';

export const CharacteristicsStyledAP = styled(CharacteristicsStyled)`
    .title {
        font-size: ${rem(24)};
        padding-bottom: ${rem(15)};

        @media (min-width: ${breakpoints.sm}px) {
            font-size: ${rem(30)};
        }
    }

    .subTitle {
        font-size: ${rem(18)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .sectionTitle {
        font-size: ${rem(18)};
        text-transform: uppercase;
        display: block;
        color: ${({ theme }) => theme.colors.black};
        margin-top: ${rem(40)};
    }

    .sectionSubTitle {
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.black};
        font-size: ${rem(14)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        svg {
            width: ${rem(18)};
            height: ${rem(18)};

            path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .primaryTechs {
        background: ${({ theme }) => theme.colors.grey7};
        font-size: ${rem(14)};
    }

    .secondaryTechs {
        font-size: ${rem(12)};
    }

    .detailTechs {
        font-size: ${rem(12)};
    }

    .characteristicsTechs {
        font-size: ${rem(12)};
    }

    .legalText {
        margin-top: ${rem(45)};
        font-size: ${rem(10)};
        color: ${({ theme }) => theme.colors.grey12};

        a {
            color: ${({ theme }) => theme.colors.primary};
            padding-left: ${rem(4)};
        }
    }
`;
